import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_COMMENTARY_API_URL } from './Constants';
import { AICommentaryLRO, AICommentaryTranslateRequest, AICommentaryTranslateResponse } from './types';

export const awCommentaryApi = axios.create();

interface Settings extends AGraphApiSettings {
  getConfigurationDirectoryFn?: () => string | undefined;
}

export const awProposalAnalyticsSettings: Settings = {};

awCommentaryApi.interceptors.request.use((config) => {
  const { getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awProposalAnalyticsSettings;

  const baseURL = AW_COMMENTARY_API_URL;
  const configurationDirectory = getConfigurationDirectoryFn?.();

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      configurationDirectory,
    },
    data: {
      ...config.data,
      overrideConfigDirectory: configurationDirectory,
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());
  return updatedConfig;
});

export const getAICommentaryForId = (id: string): Promise<AxiosResponse<AICommentaryLRO>> =>
  awCommentaryApi.get(`/v1/longRunningOperations/${id}`);

export const translateAICommentary = ({
  previousLongRunningOperationId,
  lng,
  pkg,
}: AICommentaryTranslateRequest): Promise<AxiosResponse<AICommentaryTranslateResponse>> =>
  awCommentaryApi.post(`/v1/commentary:translate`, {
    previousLongRunningOperationId,
    locale: lng,
    pkg,
  });
